export default __webpack_public_path__ + "static/media/GoodPotion.6ec328b8.svg";